import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import type { Role } from '@/modules/auth/roles';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface RemoveRoleParams {
  userId: string;
  role: Role;
}

export const useRemoveRoleMutation = () => {
  return useMutation({
    mutationFn: async ({ userId, role }: RemoveRoleParams) => {
      await fetchClient.DELETE('/administration/users/{userId}/roles/{role}', {
        params: {
          path: {
            userId,
            role,
          },
        },
      });
    },
    onSettled: () => {
      invalidateQuery(usersQueryKeys.list())();
    },
  });
};
